import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes } from 'react';

import { cx } from '../lib/cx';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

/** Text input primitive. `invalid` wires `aria-invalid` and the error border. */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid, className, type = 'text', ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      className={cx('ds-input', className)}
      aria-invalid={invalid === true ? true : undefined}
      {...rest}
    />
  );
});

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid, className, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      className={cx('ds-textarea', className)}
      aria-invalid={invalid === true ? true : undefined}
      {...rest}
    />
  );
});
